import React, { useState, useEffect } from 'react';

function IframeTracking({ url }) {
  const [key, setKey] = useState(0); // Used to force iframe re-render

  useEffect(() => {
    const intervalId = setInterval(() => {
      setKey(prevKey => prevKey + 1); // Increment key to force re-render
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
    <iframe
      key={key} // Key prop forces a re-render
      src={url}
      title="Delivery Tracking"
      width="100%"
      //height="600px" // Adjust height as needed
      style={{ border: 'none', height: '50vh'}}
    />
  );
}

export default IframeTracking;